(function() {
    // Id of the dynamic cart-upsell container. The Liquid-generated definition
    // was lost when this script moved from an inline block to an asset (#426);
    // no element carries this id today (upsell renders server-side), and the
    // existing null guards below handle its absence.
    var containerId = 'cart-drawer-upsell-container';

    // Slider initialization function - will be called after HTML is loaded
    window.initSliderInteractions = function() {
      const slider = document.querySelector('.cart-upsell-items');
      if (!slider) return;
      
      // Already initialized? Skip
      if (slider.dataset.sliderInit === 'true') return;
      slider.dataset.sliderInit = 'true';
      
      // Mouse drag for desktop - smooth and simple
      let isDown = false;
      let startX;
      let scrollLeft;
      let isDragging = false;
      
      slider.addEventListener('mousedown', (e) => {
        isDown = true;
        isDragging = false;
        slider.style.cursor = 'grabbing';
        startX = e.pageX;
        scrollLeft = slider.scrollLeft;
      });
      
      document.addEventListener('mouseup', () => {
        if (isDown) {
          isDown = false;
          slider.style.cursor = 'grab';
        }
      });
      
      slider.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        isDragging = true;
        const x = e.pageX;
        const walk = (startX - x);
        slider.scrollLeft = scrollLeft + walk;
      });
      
      // Prevent click on links after drag
      slider.addEventListener('click', (e) => {
        if (isDragging) {
          e.preventDefault();
          e.stopPropagation();
          isDragging = false;
        }
      }, true);
      
      // Touch events for mobile swipe with momentum
      let touchStartX = 0;
      let touchStartY = 0;
      let touchScrollLeft = 0;
      let isTouching = false;
      let isHorizontalSwipe = null;
      let lastTouchX = 0;
      let lastTouchTime = 0;
      let velocity = 0;
      let momentumId = null;
      
      slider.addEventListener('touchstart', (e) => {
        // Stop any ongoing momentum
        if (momentumId) {
          cancelAnimationFrame(momentumId);
          momentumId = null;
        }
        
        isTouching = true;
        isHorizontalSwipe = null;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchScrollLeft = slider.scrollLeft;
        lastTouchX = touchStartX;
        lastTouchTime = Date.now();
        velocity = 0;
      }, { passive: true });
      
      slider.addEventListener('touchmove', (e) => {
        if (!isTouching) return;
        
        const touchX = e.touches[0].clientX;
        const touchY = e.touches[0].clientY;
        const diffX = touchStartX - touchX;
        const diffY = touchStartY - touchY;
        
        // Determine swipe direction on first move
        if (isHorizontalSwipe === null) {
          isHorizontalSwipe = Math.abs(diffX) > Math.abs(diffY);
        }
        
        // Only handle horizontal swipes
        if (isHorizontalSwipe) {
          e.preventDefault();
          
          // Calculate velocity for momentum
          const now = Date.now();
          const dt = now - lastTouchTime;
          if (dt > 0) {
            velocity = (lastTouchX - touchX) / dt;
          }
          lastTouchX = touchX;
          lastTouchTime = now;
          
          slider.scrollLeft = touchScrollLeft + diffX;
        }
      }, { passive: false });
      
      slider.addEventListener('touchend', () => {
        if (!isTouching) return;
        isTouching = false;
        
        // Apply momentum scrolling
        if (isHorizontalSwipe && Math.abs(velocity) > 0.1) {
          const friction = 0.95;
          const minVelocity = 0.1;
          
          const momentum = () => {
            velocity *= friction;
            slider.scrollLeft += velocity * 16;
            
            if (Math.abs(velocity) > minVelocity) {
              momentumId = requestAnimationFrame(momentum);
            }
          };
          
          momentumId = requestAnimationFrame(momentum);
        }
        
        isHorizontalSwipe = null;
      });
      
      // Trackpad and wheel horizontal scroll
      slider.addEventListener('wheel', (e) => {
        if (Math.abs(e.deltaX) > 0 || e.shiftKey) {
          e.preventDefault();
          const delta = e.deltaX !== 0 ? e.deltaX : e.deltaY;
          slider.scrollLeft += delta;
        }
      }, { passive: false });
    };
    
    // Define with force parameter
    window.initCartUpsell = function(force, cartData) {
      const container = document.getElementById(containerId);
      if (!container) return;
      
      // If force is true, we bypass the check. 
      // Otherwise, avoid double init if already populated and visible
      if (!force && container.children.length > 0 && container.style.display !== 'none') return;

      async function loadUpsells() {
        try {
          let cart = cartData;
          if (!cart) {
            const cartRes = await fetch('/cart.js');
            cart = await cartRes.json();
          }
          
          if (cart.items.length === 0) {
            container.innerHTML = '';
            container.style.display = 'none';
            return;
          }

          const product_id = cart.items[0].product_id;
          const recommendationsUrl = `/recommendations/products?section_id=cart-drawer-upsell&product_id=${product_id}&limit=4`;
          
          const res = await fetch(recommendationsUrl);
          const text = await res.text();
          
          if (text.trim().length > 0) {
            container.innerHTML = text;
            container.style.display = 'block';
            
            container.querySelectorAll('.cart-upsell-form').forEach(form => {
              form.addEventListener('submit', async (e) => {
                e.preventDefault();
                const btn = form.querySelector('button');
                const originalText = btn.innerText;
                btn.innerText = '...';
                
                const formData = new FormData(form);
                await fetch('/cart/add.js', { method: 'POST', body: formData });
                
                btn.innerText = '✓';
                // Refresh to update cart contents
                window.location.reload(); 
              });
            });
            
            // Initialize slider interactions after HTML is inserted
            initSliderInteractions();
          } else {
              container.style.display = 'none';
          }
          
        } catch (e) {
          console.error('Upsell error:', e);
        }
      }

      // Observe internal list changes (e.g. quantity updates)
      // We still attach observer if not present, to catch internal changes within the list if they don't trigger full morph
      const list = document.querySelector('.cart-drawer__items');
      if(list && !list.dataset.upsellObserved) {
        // Debounce simplistic observer
        let timeout;
        const observer = new MutationObserver(() => {
             clearTimeout(timeout);
             timeout = setTimeout(() => loadUpsells(), 100);
        });
        // We only care about childList changes that are NOT the recommendation container itself
        // But since container is a child, we must be careful.
        // Actually, initCartUpsell(true) is called manually now, so the observer is less critical for the main update flow
        // But let's keep it for fallback.
        observer.observe(list, { childList: true, subtree: true });
        list.dataset.upsellObserved = "true";
      }
      
      loadUpsells();
    }

    // 1. Run on load
    if(document.readyState !== 'loading') window.initCartUpsell(false);
    else document.addEventListener('DOMContentLoaded', () => window.initCartUpsell(false));
    
    // 2. Run when a cart drawer open button is clicked
    document.addEventListener('click', (e) => {
        if(e.target.closest('[data-testid="cart-drawer-trigger"], .header-actions__cart-icon, [href="/cart"]')) {
            setTimeout(() => {
              window.initCartUpsell(true);
              if (window.initCartTimer) window.initCartTimer();
            }, 200); 
        }
    });

    // 3. Global observer for Drawer injection
    const bodyObserver = new MutationObserver((mutations) => {
        for(const mutation of mutations) {
            for(const node of mutation.addedNodes) {
                if(node.nodeType === 1 && (node.id === containerId || node.querySelector('#'+containerId))) {
                    window.initCartUpsell(true);
                    if (window.initCartTimer) window.initCartTimer();
                    return;
                }
            }
        }
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });

  })();
